import { FC } from "react";
import styles from "./Avatar.module.scss";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { classNames } from "../../Utilities";

interface AvatarProps {
    src?: string | null;
    onClick?: () => void;
    size?: string;
}

export const Avatar: FC<AvatarProps> = (props) => {
    return (
        <div
            className={classNames([styles.avatar, !!props.onClick && styles.clickable])}
            style={{ width: props.size ?? "200px", aspectRatio: 1 }}
            onClick={() => !!props.onClick && props.onClick()}
        >
            {!!props.src && (
                <img
                    className={classNames([!!props.onClick && styles.clickable])}
                    src={props.src}
                    draggable={false} // This is to prevent the image being dragged on the ranking screen
                    onClick={() => !!props.onClick && props.onClick()}
                />
            )}
            {!props.src && <FontAwesomeIcon icon={faUser} size="10x" />}
        </div>

    );
};